// extracted by mini-css-extract-plugin
module.exports = {"right":"right_right__1K1Wk"};